/**
 * Renders SVG edges between nodes in the graph.
 */
import React from 'react';
import { buildEdgePath } from '../../utils/canvasUtils';
import { OstNode } from 'types';

type CanvasEdgeProps = {
    edges: Array<{ from: OstNode; to: OstNode; relation?: boolean }>;
    nodeHeights: Record<string, number>;
};

export default function CanvasEdge({ edges, nodeHeights }: CanvasEdgeProps) {
    return (
        <>
            {edges.map((edge, i) => {
                if (edge.relation) {
                    // Relation edges are rendered in the top overlay layer.
                    return null;
                }

                const result = buildEdgePath(edge.from, edge.to, nodeHeights);
                if (result === null) return null;
                const { d, color } = result;
                return (
                    <path
                        key={`edge-${edge.from.id}-${edge.to.id}-${i}`}
                        d={d}
                        fill='none'
                        stroke={color}
                        strokeWidth={1.8}
                        strokeLinecap='round'
                        strokeLinejoin='round'
                        opacity={0.78}
                    />
                );
            })}
        </>
    );
}
